<template>
  <div ref="bar" class="tabs">
    <button
      v-for="tab in tabs"
      :key="tab.value"
      class="tab"
      :class="{ 'tab--active': modelValue === tab.value }"
      @click="$emit('update:modelValue', tab.value)"
    >
      {{ tab.label }}
      <span v-if="tab.count !== undefined && tab.count !== null" class="tab__count">
        {{ tab.count }}
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'TabBar',
  // Vue 2 v-model mapping
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    tabs: {
      type: Array,
      required: true
    },
    modelValue: {
      type: [String, Number],
      default: null
    }
  },
  emits: ['update:modelValue'],
  watch: {
    modelValue () { this.$nextTick(this.scrollActiveIntoView) }
  },
  mounted () {
    this.scrollActiveIntoView()
  },
  methods: {
    // Cuando la barra se desliza (juego largo en pantalla angosta) la pestaña
    // activa puede quedar fuera de cuadro, y entonces no hay NADA en pantalla
    // que diga qué se está mirando: llegar por ?estateId= a la propiedad número
    // trece dejaba la tira empezada en «Todos» y una sola fila sin explicación.
    // Se mueve sólo el carril horizontal — tocar el scroll vertical de la página
    // al cambiar de pestaña sería peor que no hacer nada.
    scrollActiveIntoView () {
      const bar = this.$refs.bar
      if (!bar || bar.scrollWidth <= bar.clientWidth) return
      const index = this.tabs.findIndex(t => t.value === this.modelValue)
      const el = index >= 0 ? bar.children[index] : null
      if (!el) return
      const barBox = bar.getBoundingClientRect()
      const elBox = el.getBoundingClientRect()
      // Centrar en el carril; el navegador recorta solo en los extremos
      bar.scrollLeft += (elBox.left - barBox.left) - (bar.clientWidth - elBox.width) / 2
    }
  }
}
</script>
